import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiZap } = FiIcons;

function SupportPanel() {
  return (
    <section className="support-panel" aria-labelledby="support-title">
      <div className="support-icon">
        <SafeIcon icon={FiZap} />
      </div>

      <div className="support-copy">
        <p>Keep the Signal Moving</p>
        <h2 id="support-title">Help Us Keep Making Great Voices Heard</h2>
        <span>
          Every pass, membership and patron contribution helps sustain the
          production, outreach and relationships behind these rooms. Some
          people come to experience AIPosse. Some stay for the community. Some
          help us build what comes next.
        </span>
        <strong>
          With gratitude from South Dakota,
          <br />
          Joe
        </strong>
      </div>
    </section>
  );
}

export default SupportPanel;